import React, { createContext, useContext, useState } from 'react'

export const CommandMenuOpenContext: React.Context<FetchCommandMenuOpen> =
  createContext<FetchCommandMenuOpen>({
    isOpen: false,
    setIsOpen: async () => {
      throw new Error('Not implemented yet')
    },
  })

// Provider component that wraps your app and makes auth object ...
// ... available to any child component that calls useAuth().

export const ProvideCommandMenuOpen = ({
  children,
}: React.PropsWithChildren<IProps>): React.ReactElement => {
  const value: FetchCommandMenuOpen = useFetchCommandMenuOpen()
  return <CommandMenuOpenContext.Provider value={value}>{children}</CommandMenuOpenContext.Provider>
}

// Hook for child components to get the auth object ...
// ... and re-render when it changes.

export const useCommandMenuOpen = (): FetchCommandMenuOpen => {
  return useContext<FetchCommandMenuOpen>(CommandMenuOpenContext)
}

interface IProps {}

interface FetchCommandMenuOpen {
  isOpen: boolean
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
}

export const useFetchCommandMenuOpen = (): FetchCommandMenuOpen => {
  const [isOpen, setIsOpen] = useState(false)

  return { isOpen, setIsOpen }
}
